import { render, staticRenderFns } from "./VcitaButtonWithBadge.vue?vue&type=template&id=22de4848"
import script from "./VcitaButtonWithBadge.vue?vue&type=script&lang=js"
export * from "./VcitaButtonWithBadge.vue?vue&type=script&lang=js"
import style0 from "./VcitaButtonWithBadge.vue?vue&type=style&index=0&id=22de4848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports